// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main App Styles */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1 1;
  /* padding-bottom: 2rem; */
}

/* General Styles */
h1, h2, h3, h4, h5, h6 {
  margin-bottom: 1rem;
  font-weight: 600;
}

/* Card Styles */
.card {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

.card-header {
  font-weight: 600;
  background-color: #f8f9fa;
}

/* Table Styles */
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.sortable-header {
  cursor: pointer;
}

.sortable-header:hover {
  background-color: #e9ecef;
}

/* Expanded Row */
.expanded-content {
  background-color: #f8f9fa;
}

/* Button Styles */
.btn-primary {
  background-color: #0d6efd;
}

/* Alert Styles */
.alert {
  margin-bottom: 1.5rem;
}

/* Progress Bar */
.progress {
  height: 1.5rem;
}

/* Custom Utilities */
.fw-bold {
  font-weight: 600 !important;
}

.text-muted {
  color: #6c757d !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/* Main App Styles */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nmain {\n  flex: 1;\n  /* padding-bottom: 2rem; */\n}\n\n/* General Styles */\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n/* Card Styles */\n.card {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n}\n\n.card-header {\n  font-weight: 600;\n  background-color: #f8f9fa;\n}\n\n/* Table Styles */\n.table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n}\n\n.sortable-header {\n  cursor: pointer;\n}\n\n.sortable-header:hover {\n  background-color: #e9ecef;\n}\n\n/* Expanded Row */\n.expanded-content {\n  background-color: #f8f9fa;\n}\n\n/* Button Styles */\n.btn-primary {\n  background-color: #0d6efd;\n}\n\n/* Alert Styles */\n.alert {\n  margin-bottom: 1.5rem;\n}\n\n/* Progress Bar */\n.progress {\n  height: 1.5rem;\n}\n\n/* Custom Utilities */\n.fw-bold {\n  font-weight: 600 !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .container {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
